import { Directive, Input, TemplateRef } from '@angular/core'
import { OptionContext } from './persistent-dropdown.types'

@Directive({
  selector: '[optValue]'
})
export class OptValueDirective<T> {
  @Input('optValue') value: T

  constructor(public templateRef: TemplateRef<OptionContext<T>>) {}
}
